import getEnv, { PROD } from './getEnv';

/**
 * Checks sessionStorage for values of wsTrackingUser (set in ws-tracking) and returns true/false if value is 'track' or not.
 *
 * @returns {boolean} true if wsTrackingUser is 'track', otherwise false
 * @example
 */
const userShouldBeTracked = () =>
	getEnv() !== PROD ||
	(getEnv() === PROD && sessionStorage.getItem('wsTrackingUser') === 'track');

export default userShouldBeTracked;
